import { Button, Flex, Form, Modal, Row, Switch, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import iconLock from '../../../assets/images/schedules/icon-lock-switch.svg';
import iconUnLock from '../../../assets/images/schedules/icon_unlock-switch.svg';
import iconLockAgent from '../../../assets/images/schedules/lock-agent.svg';
import iconLockApi from '../../../assets/images/schedules/lock-api.svg';
import iconLockCompany from '../../../assets/images/schedules/lock-company.svg';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ListScheduleSelector, setListLock } from '../../../redux/slice/schdules/scheduleSlice';
import '../../schedules/Schedules.scss';

const LockSegmentModal: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  loading,
  lockItemActive,
  route,
  routeId,
  className,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const { locks } = useAppSelector(ListScheduleSelector);
  const [formLock] = Form.useForm();
  const dispatch = useAppDispatch();
  const watchCompany = Form.useWatch('company', formLock);
  const watchAgent = Form.useWatch('agent', formLock);
  const watchApi = Form.useWatch('api', formLock);
  const modalHandleOk = () => {
    onOk();
  };
  const modalHandleCancel = () => {
    const status = {
      company: watchCompany,
      agent: watchAgent,
      api: watchApi,
    };
    const newLock = {
      route: routeId,
      status: status,
    };
    let updatedLocks = Array.isArray(locks) ? [...locks] : [];
    const existingRouteIndex = updatedLocks?.findIndex((lock: any) => lock?.route === routeId);
    if (existingRouteIndex !== -1) {
      updatedLocks[existingRouteIndex] = newLock;
    } else {
      updatedLocks?.push(newLock);
    }
    
    dispatch(setListLock(updatedLocks));
    formLock.resetFields();
    onCancel();
  };
  const onFinish = (values: any) => {
    const status = {
      company: values.company,
      agent: values.agent,
      api: values.api,
    };
    const newLock = {
      route: routeId,
      status: status,
    };
    let updatedLocks = Array.isArray(locks) ? [...locks] : [];
    const existingRouteIndex = updatedLocks?.findIndex((lock: any) => lock?.route === routeId);
    if (existingRouteIndex !== -1) {
      updatedLocks[existingRouteIndex] = newLock;
    } else {
      updatedLocks?.push(newLock);
    }
    dispatch(setListLock(updatedLocks));
    formLock.resetFields();
    onCancel();
  };
  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  useEffect(() => {
    if (lockItemActive[0]?.route) {
      formLock.setFieldsValue({
        agent: lockItemActive[0]?.status?.agent,
        company: lockItemActive[0]?.status?.company,
        api: lockItemActive[0]?.status?.api,
      });
    }
  }, [formLock, lockItemActive, modalOpen]);

  
  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      maskClosable={false}
      centered
      width={560}
      footer={
        <>
          <Row className="d-flex justify-content-end mt-1 pr-4">
            <Flex>
              <Button loading={loading} key="cancel" className="btn-cancel me-3" onClick={() => modalHandleCancel()}>
                Đóng
              </Button>
              <Button
                key="submit"
                type="primary"
                loading={loading}
                className="w-160 h-btn-48 btn-success mr-0"
                htmlType="submit"
                onClick={formLock.submit}
              >
                Lưu
              </Button>
            </Flex>
          </Row>
        </>
      }
      className="modal-segment-block booking-schedule-modal "
      styles={{ body: { maxHeight: '650px', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '30px' } }}
    >
      <Typography
        className="fs-18 fw-600"
        style={{ color: '#444444', paddingBottom: '12px', borderBottom: '1px solid #EEEEEE' }}
      >
        Khóa chặng
      </Typography>
      <div className={`block-bg-color-200 mt-4`}>
        <div className={`block-price-route ${className}`}>
          <p className={`color-700 fs-16 fw-600 ${className}`}>{route}</p>
        </div>
      </div>
      <Form
        name="segment-lock-form"
        layout="vertical"
        form={formLock}
        onFinish={onFinish}
        className="mt-4 segment-price-form"
        colon={false}
        validateTrigger="onSubmit"
        initialValues={{
          company: false,
          agent: false,
          api: false,
        }}
      >
        <div className="segment-lock-block">
          <div
            className={`cursor-pointer ${watchCompany ? '' : 'checked'} segment-lock-item`}
            onClick={() => formLock.setFieldsValue({ company: !watchCompany })}
          >
            <Flex gap={12} align="center" className="w-85">
              <img src={iconLockCompany} alt="" /> <span> Khoá nhà xe</span>
            </Flex>
            <Form.Item name="company" className="booking-input-disable w-15" valuePropName="checked">
              <Switch
                checkedChildren={<img src={iconLock} alt="" />}
                checked={watchCompany}
                unCheckedChildren={<img src={iconUnLock} alt="" />}
              />
            </Form.Item>
          </div>
          <div
            className={`cursor-pointer ${watchAgent ? '' : 'checked'} segment-lock-item`}
            onClick={() => formLock.setFieldsValue({ agent: !watchAgent })}
          >
            <Flex gap={12} align="center" className="w-85">
              <img src={iconLockAgent} alt="" /> <span>Khoá đại lý</span>
            </Flex>
            <Form.Item name="agent" className="booking-input-disable w-15" valuePropName="checked">
              <Switch
                checkedChildren={<img src={iconLock} alt="" />}
                unCheckedChildren={<img src={iconUnLock} alt="" />}
                checked={watchAgent}
              />
            </Form.Item>
          </div>
          <div
            className={`cursor-pointer ${watchApi ? '' : 'checked'} segment-lock-item`}
            onClick={() => formLock.setFieldsValue({ api: !watchApi })}
          >
            <Flex gap={12} align="center" className="w-85">
              <img src={iconLockApi} alt="" /> <span>Khoá API</span>
            </Flex>
            <Form.Item name="api" className="booking-input-disable w-15" valuePropName="checked">
              <Switch
                checkedChildren={<img src={iconLock} alt="" />}
                unCheckedChildren={<img src={iconUnLock} alt="" />}
                checked={watchApi}
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default LockSegmentModal;
